import { createI18n } from 'vue-i18n'
import fr from './locales/fr-FR.json'
import en from './locales/en-US.json'

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: "fr-FR",
  fallbackLocale: "fr-FR",
  messages: {
    fr,
    "fr-FR": fr,
    en,
    "en-US": en,
  },
  silentTranslationWarn: true, // Suppress translation warnings
  silentFallbackWarn: true, // Suppress fallback warnings
  missingWarn: false, // Disable missing key warnings
  fallbackWarn: false, // Suppress warnings when falling back to fallbackLocale
  missing: (locale, key) => {
    return key; // Return the key as the fallback text
  },
})
